import { PrivateRoute } from "helpers/PrivateRoute";
import Trips from "pages/trips/Index";
import { Route } from "react-router-dom";
import React from "react";

const index = () => {
    return (<>
      <Route
        path="trips"
        element={
          <PrivateRoute>
            <Trips />
          </PrivateRoute>
        }
      />
    </>);
}

export default index;